import React, { createContext, useContext, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface ModalContextType {
  isInterestModalOpen: boolean;
  isCalendlyModalOpen: boolean;
  handleBookNowClick: () => void;
  handleInterestYes: () => void;
  handleInterestNo: () => void;
  handleCalendlyClose: () => void;
  handleInterestModalClose: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isInterestModalOpen, setIsInterestModalOpen] = useState(false);
  const [isCalendlyModalOpen, setIsCalendlyModalOpen] = useState(false);

  const handleBookNowClick = () => {
    setIsInterestModalOpen(true);
  };

  const handleInterestYes = () => {
    setIsInterestModalOpen(false);
    setIsCalendlyModalOpen(true);
  };

  const handleInterestNo = () => {
    setIsInterestModalOpen(false);
    navigate('/software-rejection');
  };

  const handleCalendlyClose = () => {
    setIsCalendlyModalOpen(false);
  };

  const handleInterestModalClose = () => {
    setIsInterestModalOpen(false);
  };

  const value: ModalContextType = {
    isInterestModalOpen,
    isCalendlyModalOpen,
    handleBookNowClick,
    handleInterestYes,
    handleInterestNo,
    handleCalendlyClose,
    handleInterestModalClose,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};
